export default "__VITE_ASSET__B$76us_h__"